import React from 'react';
import PropTypes from 'prop-types';
import { List, Subheader, Divider, Paper } from 'material-ui';
import style from '../../../styles/styles';
import Error from '../../common/Error/Error';
import QuizItem from '../QuizItem/QuizItem';

class QuizList extends React.Component {

    static propTypes = {
        quizzes: PropTypes.array,
        title: PropTypes.string,
        user: PropTypes.object,
        app: PropTypes.object
    }
    render() {
        const { quizzes, title, user, app } = this.props;
        let content;
        if (!quizzes || quizzes.length === 0) {
            content =
                <Error
                    title="No data"
                    subtitle="Add some achievements"
                />;
        } else {
            content = quizzes
                .sort((a, b) => {return a.name - b.name;})
                .map(function (quiz, index) {
                    return <div key={quiz.id}>
                        <QuizItem
                            app={app}
                            user={user}
                            quiz={quiz}
                        />
                        {index !== (quiz.length - 1) && <Divider inset={true} />}
                    </div>;
                });
        }
        return (
            <Paper>
                <List>
                    <Subheader style={style.subHeader}>{title}</Subheader>
                    {content}
                </List>
            </Paper>
        );
    }
}

export default QuizList;



// WEBPACK FOOTER //
// src/components/quiz/QuizList/QuizList.js